import React, { Component, } from 'react'
import DownloadLink from '../../components/availableactions/downloadLink.js'
import FullReplacementLink from '../../components/availableactions/fullReplacementLink.js'
import AddonLink from '../../components/availableactions/addOnLink.js'
import CancelLink from '../../components/availableactions/cancelLink.js'
import SubmitLink from '../../components/availableactions/submitLink.js'
import config from '../../resource/appConfig.js'

const U = config.reqStatuses.uploaded,
    VIP = config.reqStatuses.validationInProgress,
    VF = config.reqStatuses.validationFailed,
    VSW = config.reqStatuses.validationSuccesswithErrors,
    VS = config.reqStatuses.validationSuccessful,
    TO = config.reqStatuses.timedOut

class statusButtons extends Component {
    render() {
        const reqstatus = this.props.PassDataItems.REQ_STATUS
        const uploadType = this.props.PassDataItems.UPLOAD_TYPE
        const errorCount = this.props.PassDataItems.ERROR_COUNT
        return (
            <ul className="request-action-list col-xs-3" aria-live="polite">
                {(((reqstatus) === VIP) || ((reqstatus) === U)) ? null : null}
                {(((reqstatus) === VS)) ? <div>
                    <FullReplacementLink />
                    <AddonLink PassDataItems={this.props.PassDataItems} />
                    <DownloadLink apiAuthHeaders={this.props.apiAuthHeaders} PassDataItems={this.props.PassDataItems}
                                  index={this.props.index} />
                    <CancelLink apiAuthHeaders={this.props.apiAuthHeaders} PassDataItems={this.props.PassDataItems}
                                index={this.props.index} />
                </div> : null}
                {(((reqstatus) === VSW)) ? <div>
                    <SubmitLink apiAuthHeaders={this.props.apiAuthHeaders} PassDataItems={this.props.PassDataItems} />
                    <FullReplacementLink />
                    <AddonLink PassDataItems={this.props.PassDataItems} />
                    {(errorCount && errorCount <= config.erroneousRowsCountLimit) ?
                        <DownloadLink apiAuthHeaders={this.props.apiAuthHeaders}
                                      PassDataItems={this.props.PassDataItems} index={this.props.index} /> : null}
                    <CancelLink apiAuthHeaders={this.props.apiAuthHeaders} PassDataItems={this.props.PassDataItems}
                                index={this.props.index} />
                </div> : null}
                {(((reqstatus) === VF)) ? <div>
                    {(errorCount && errorCount <= config.erroneousRowsCountLimit) ?
                        <DownloadLink apiAuthHeaders={this.props.apiAuthHeaders}
                                      PassDataItems={this.props.PassDataItems} index={this.props.index} /> : null}
                    <FullReplacementLink />
                    <CancelLink apiAuthHeaders={this.props.apiAuthHeaders} PassDataItems={this.props.PassDataItems}
                                index={this.props.index} />
                    <AddonLink PassDataItems={this.props.PassDataItems} />
                </div> : null}
                {((uploadType !== '4' && reqstatus === TO)) ? <div>
                    <FullReplacementLink />
                    <CancelLink apiAuthHeaders={this.props.apiAuthHeaders} PassDataItems={this.props.PassDataItems}
                                index={this.props.index} />
                </div> : null}
            </ul>
        )
    }
}

export default statusButtons
